import { SettingService } from './../../../shared/services/setting.service';
import { ISetting } from './../../../_models/cms/ISetting';
import { ISpouseOutInfo } from '../../../_models/profile-sections/ISpouseOutInfo';
import { MediaFileService } from '../../../shared/services/media-file.service';
import { CommonService } from '../../../shared/services/common.service';
import { SpouseOutInfoService } from '../../../shared/services/spouse-out-info.service';
import { ToastrService } from 'ngx-toastr';
import { IKeyValuePair } from '../../../_models/common/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { DatePipe } from '@angular/common';   

@Component({
  selector: 'app-spouse-out-info-form',
  templateUrl: './spouse-out-info-form.component.html'
})

export class SpouseOutInfoComponent implements OnInit {
  titles: string[] = ["Mr.", "Mrs.", "Ms."];
  skeleton: boolean = true;
  loading: boolean;
  title: string = 'Add Spouse Details (If out of NVS)';
  spouseOutInfo: ISpouseOutInfo;
  spouseOutInfoForm: FormGroup;
  id;

  jobTypes: IKeyValuePair[];
  jobPlaceTypes: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];

  barWidth: number = 0;
  isProgress: boolean = false;
  fileToUpload: File = null;

  setting: ISetting;

  constructor(private router: Router,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private mediaFileService: MediaFileService,
    private service: SpouseOutInfoService,
    private commonService: CommonService,
    private settingService: SettingService) {
  }

  async ngOnInit() {
    this.setting = await this.settingService.getSetting();
    if (this.setting && !this.setting.isProfile) {
      this.toastrService.warning("profile module closed!");
      this.router.navigate(['/employee']);
      return;
    }
    
    this.createSpouseOutInfoForm();
    this.bindDropDown();

    if (this.setting) {
      this.spouseOutInfoForm.patchValue({
        financialYearId: this.setting.financialYearId,
      });
    }

    this.service.logged().subscribe((response: ISpouseOutInfo) => {
      if (response) {
        this.spouseOutInfo = response;
        this.id = this.spouseOutInfo.id;
        this.title = 'Edit Spouse Details (If out of NVS)';
        this.setValueSpouseOutInfoForm();
      }
    },
    (error) => console.log('HTTP Error', error),
    () => this.skeleton = false);
  }

  bindDropDown() {
    this.commonService.getJobTypes().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.jobTypes = response;
      }
    });
    this.commonService.getJobPlaceTypes().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.jobPlaceTypes = response;
      }
    });
    this.commonService.getStates().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.districts = response;
      }
    });
  }

  createSpouseOutInfoForm() {
    this.spouseOutInfoForm = this.fb.group({
      id: ['0'],
      financialYearId: [this.setting?.financialYearId, Validators.required],
      profileId: [''],
      title: ['', Validators.required],
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: [''],
      email: ['', [Validators.required, Validators.email]],
      birthDate: ['', [Validators.required, Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
      isSameDistt: [false, Validators.required],
      designation: ['', Validators.required],
      jobPlaceTypeId: ['', Validators.required],
      jobTypeId: ['', Validators.required],
      stateId: [''],
      districtId: [''],
      spouseCertId: ['', Validators.required],
      certIssueDate: ['', [Validators.required, Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
      isActive: [true, Validators.required]
    });
  }

  setValueSpouseOutInfoForm() {

    if (this.spouseOutInfo.stateId) {
      this.getDistricts(this.spouseOutInfo.stateId);
    }

    this.spouseOutInfoForm.patchValue({
      id: this.spouseOutInfo.id,
      financialYearId: this.spouseOutInfo.financialYearId,
      profileId: this.spouseOutInfo.profileId,
      title: this.spouseOutInfo.title,
      firstName: this.spouseOutInfo.firstName,
      middleName: this.spouseOutInfo.middleName,
      lastName: this.spouseOutInfo.lastName,
      email: this.spouseOutInfo.email,
      birthDate: this.datePipe.transform(this.spouseOutInfo.birthDate, 'dd-MM-yyyy'),
      isSameDistt: this.spouseOutInfo.isSameDistt,
      designation: this.spouseOutInfo.designation,
      jobPlaceTypeId: this.spouseOutInfo.jobPlaceTypeId,
      jobTypeId: this.spouseOutInfo.jobTypeId,
      stateId: this.spouseOutInfo.stateId,
      districtId: this.spouseOutInfo.districtId,
      spouseCertId: this.spouseOutInfo.spouseCertId,
      certIssueDate: this.datePipe.transform(this.spouseOutInfo.certIssueDate, 'dd-MM-yyyy'),
      isActive: this.spouseOutInfo.isActive
    });
  }

  save() {
    if (this.spouseOutInfoForm.valid) {
      this.loading = true;
      this.spouseOutInfo = Object.assign({}, this.spouseOutInfoForm.value);
      if (this.id) {
        this.service.update(this.id, this.spouseOutInfo).subscribe((response: ISpouseOutInfo) => {
          if (response) {
            this.toastrService.success('spouse Details updated successful');
            this.router.navigate(['/employee/profile/other-details']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.spouseOutInfo).subscribe((response: ISpouseOutInfo) => {
          if (response) {
            this.toastrService.success('spouse Details added successful');
            this.router.navigate(['/employee/profile/other-details']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  delete() {
    if (!confirm('Are you sure you want to clear?')) return;

    this.service.delete(this.id).subscribe(() => {
      this.toastrService.success('disability information cleared successful');
      this.router.navigate(['/employee/profile/other-details']);
    });
  }

  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
  }

  OnSubmit(inputDoc) {

    this.mediaFileService.authPostSingleFile(this.fileToUpload).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.isProgress = true;
          this.barWidth = Math.round(event.loaded / event.total * 100);
        }
        else if (event.type === HttpEventType.Response) {
          this.isProgress = false;
          this.barWidth = 0;
          this.spouseOutInfoForm.patchValue({
            spouseCertId: event.body.id
          });
          this.toastrService.success('document uploaded successfully.');
        }
      },
      (error) => {
        console.log(error);
        inputDoc.value = null;
      },
      () => console.log("complete"));
  }

}
